export const contactStatus = [
  {
    id: 1,
    name: 'Active'
  },
  {
    id: 2,
    name: 'Prospective'
  },
  {
    id: 3,
    name: 'Not Active'
  },
]

export const contactType = [
  {
    id: 1,
    name: 'Client',
    code: 'DMCC',
    isDefault: true
  },
  {
    id: 2,
    name: 'Partner',
    code: 'P'
  },
  {
    id: 3,
    name: 'Partner’s Client',
    code: 'PCL'
  }
]

export const contactExtra = [
  {
    id: 1,
    name: 'Russian speaking',
    key: 'languages'
  },
  {
    id: 2,
    name: 'English speaking',
    key: 'languages'
  },
  {
    id: 3,
    name: 'no phone',
    key: 'phone'
  },
  {
    id: 4,
    name: 'no email',
    key: 'email',
    isCheck: false
  }
]

export const contactRisk = [
  {
    id: 1,
    color: 'green',
    name: 'Low'
  },
  {
    id: 2,
    color: 'yellow',
    name: 'Medium'
  },
  {
    id: 3,
    color: 'red',
    name: 'High'
  }
]


export const clientCommunicationStatus = {
  1 : '#04AB14',
  2: '#838383',
  3: '#E7E7E7',
};



// WEBPACK FOOTER //
// ./src/constants/clientInfo.js